import React from 'react';
import styles from './CarouselButton.module.css';

export interface CarouselButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  /** Theme variant */
  variant?: 'dark' | 'light' | 'glass';
  /** Button direction for icon */
  direction?: 'next' | 'prev';
  /** Border radius variant */
  rounded?: 'sm' | 'lg' | 'full';
  /** Whether to show background fill */
  fill?: boolean;
}

export const CarouselButton = React.forwardRef<
  HTMLButtonElement,
  CarouselButtonProps
>(
  (
    {
      direction = 'next',
      variant = 'light',
      rounded = 'full',
      fill = true,
      className,
      ...props
    },
    ref,
  ) => {
    const iconRotation = direction === 'next' ? '0deg' : '180deg';

    return (
      <button
        ref={ref}
        {...props}
        type="button"
        data-variant={variant}
        data-rounded={rounded}
        data-fill={fill ? 'true' : 'false'}
        className={[styles.root, className].filter(Boolean).join(' ')}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="14"
          viewBox="0 0 19 14"
          fill="none"
          style={{ transform: `rotate(${iconRotation})` }}
        >
          <path
            d="M1.60144 6.01647C1.12405 6.01647 0.73705 6.40347 0.73705 6.88086C0.73705 7.35825 1.12405 7.74525 1.60144 7.74525V6.88086V6.01647ZM18.365 7.49208C18.7025 7.15451 18.7025 6.60721 18.365 6.26964L12.864 0.768697C12.5265 0.431131 11.9792 0.431131 11.6416 0.768697C11.304 1.10626 11.304 1.65356 11.6416 1.99113L16.5313 6.88086L11.6416 11.7706C11.304 12.1082 11.304 12.6555 11.6416 12.993C11.9792 13.3306 12.5265 13.3306 12.864 12.993L18.365 7.49208ZM1.60144 6.88086V7.74525H17.7538V6.88086V6.01647H1.60144V6.88086Z"
            fill="black"
          />
        </svg>
      </button>
    );
  },
);

CarouselButton.displayName = 'CarouselButton';

export default CarouselButton;
